import * as go from 'gojs';
import * as _ from 'lodash/fp';

import { addToken, removeToken } from '@process-advisor/process-miner/processMiner/animateLifecycleVariant/addAndRemoveToken';
import { getLink } from '@process-advisor/process-miner/processMiner/animateLifecycleVariant/getLink';
import { tokenSpeed } from '@process-advisor/process-miner/processMiner/animateLifecycleVariant/consts';

type Link = {
    link: go.Link,
    length: number
}

type Point = {
    frac: number
}

export const updateTokens = (
    newTokensShowingPoints: Point[],
    links: Link[],
    diagram: go.Diagram,
    color: string
) => {
    const prevSkips = diagram.skipsUndoManager;
    diagram.skipsUndoManager = true;
    diagram.parts.each((part) => {
        const newData = _.cloneDeep(part.data);

        if (part.category !== 'token') {
            return;
        }

        if (newData.at === links.length) {
            addToken(diagram, { color, leader: newData.leader });
            removeToken(diagram, part);
            return;
        }

        const link = getLink(diagram, links[newData.at]);
        part.location = link.path.getDocumentPoint(
            link.path.geometry.getPointAlongPath(newData.frac, new go.Point())
        );
        const step = tokenSpeed * (1 / links[newData.at].length);

        newData.at = newData.frac >= 1.0 ? newData.at + 1 : newData.at;
        newData.frac = newData.frac >= 1.0 ? 0 : Math.min(1.0, newData.frac + step);

        if (part.data.leader) {
            const passedPoint = _.some(
                ({ frac }) => frac < newData.at + newData.frac
                    && frac > part.data.at + part.data.frac
            )(newTokensShowingPoints);

            if (passedPoint) {
                addToken(diagram, { color, leader: false });
            }
        }

        part.data = newData;
    });
    diagram.skipsUndoManager = prevSkips;
};
